import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useClusterById } from '@/api/generated';
import { Preview } from '@/components/blocks/preview/preview';
import { Spinner } from '@/components/ui/spinner';
import StatusBadge from '@/routes/(app)/(clusters)/components/status-badge';

interface ClusterResultsProps {
  clusterId: string;
}
const ClusterResults: FC<ClusterResultsProps> = ({ clusterId }) => {
  const { t } = useTranslation();
  const [refetch, setRefetch] = useState(true);
  const { data, isLoading } = useClusterById(clusterId, {
    query: { refetchInterval: refetch ? 2000 : false },
  });

  useEffect(() => {
    setRefetch(data?.status === 'running');
  }, [data?.status]);

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    return null;
  }

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-start gap-2'>
        <span>{data.cluster.model}</span>
        <StatusBadge status={data.status} />
      </div>
      {data.data.map((run) =>
        // eslint-disable-next-line no-nested-ternary
        run.output?.path ? (
          <Preview
            key={run.output.id}
            id={run.output.id}
            options={{ mutationKey: run.id, path: run.output.path }}
          />
        ) : run.status === 'completed' ? (
          <span className='text-destructive-foreground text-xs'>
            {t('playground.textTranslation.output.noResults')}
          </span>
        ) : (
          <StatusBadge
            key={run.id}
            status={run.status}
          />
        )
      )}
    </div>
  );
};

export default ClusterResults;
